import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CronosMembersPage } from './cronos-members';

@NgModule({
  declarations: [
    CronosMembersPage,
  ],
  imports: [
    IonicPageModule.forChild(CronosMembersPage),
  ],
})
export class CronosMembersPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cronos-members/cronos-members.module.ts